import React from 'react';
import { CardContainer } from './card-styles';
var Card = function (_a) {
    var shadowed = _a.shadowed, borderWidth = _a.borderWidth, borderRadius = _a.borderRadius, borderStyle = _a.borderStyle, borderColor = _a.borderColor, boxShadow = _a.boxShadow, children = _a.children, backgroundColor = _a.backgroundColor, shadowOnHover = _a.shadowOnHover;
    return (React.createElement(CardContainer, { shadowed: shadowed, borderWidth: borderWidth, borderRadius: borderRadius, borderStyle: borderStyle, borderColor: borderColor, backgroundColor: backgroundColor, boxShadow: boxShadow, shadowOnHover: shadowOnHover }, children));
};
export default Card;
